import { h } from 'preact';
import PropTypes from 'prop-types';

import { getClassNames } from '../../../../utils/classnames-utils';
import { IconCheck } from '../../1-foundation/icons/icons';

import { modifierList } from './props-list';

const StatusNotification = ({ message, modifiers, hasCheckIcon }) => {
  const classNames = getClassNames('c-status-notification', modifiers);

  return (
    <div className={classNames}>
      {hasCheckIcon && (
        <div className="c-status-notification__check">
          <IconCheck modifiers={['xxsmall', 'c-success']} />
        </div>
      )}
      <span className="c-status-notification__message" dangerouslySetInnerHTML={{ __html: message }} />
    </div>
  );
};

StatusNotification.propTypes = {
  message: PropTypes.string,
  modifiers: PropTypes.arrayOf(PropTypes.oneOf(modifierList)).isRequired,
  hasCheckIcon: PropTypes.bool,
};

export default StatusNotification;
